<template>
  <ul class="list_box">
    <li v-for="(item, index) in list" @click="jump(item)">
      <div class="list_div">
        <img class="leftImg" :src="item.coverPicUrl" alt="" />
        <div class="right_box">
          <p class="right_title">{{ item.courseName }}</p>
          <div class="right_bottom">
            <img
              v-if="showIcon && item.newsSourceIcon"
              :src="item.newsSourceIcon"
              alt=""
            />
            <span>{{ item.userName || item.duties }}</span>
            <span>{{ item.showTime }}</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
/*
 * props  @list  列表数据
 *        @bottomObj 右下 内容
 *        @needHighlight 是否需要关键字高亮
 *        @keys 关键字
 *        @path 转跳类型
 *
 * */
export default {
  name: '',
  props: {
    needHighlight: {
      type: Boolean,
      default: false
    },
    showIcon: {
      default: false
    },
    keys: {
      type: String,
      default: '特殊'
    },
    path: {
      default: 'courseDetail'
    },
    type: {
      default: 0
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    seachFifter(content) {
      let filtercontent = content.replace(/<|>/g, '');
      if (this.needHighlight) {
        return filtercontent.replace(
          new RegExp(this.keys, 'g'),
          '<span class=\'colorRed\'>' + this.keys + '</span>'
        );
      } else {
        return filtercontent;
      }
    },
    jump(item) {
      this.$router.push({ name: this.path, params: { id: item.id } });
    }
  },
  computed: {},
  components: {},
  mounted() {},
  filters: {
    heighLight: function(v) {
      return v + '<span>123</span>';
    }
  }
};
</script>
<style lang="less" scoped>
.list_box {
  li:last-child {
    border: none;
  }
  .list_div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 0.4rem;
    margin-top: 0.4rem;
    .leftImg {
      width: 3.306rem;
      height: 1.866rem;
      border-radius: 0.1rem;
    }
    .right_box {
      width: 62%;
      .right_title {
        font-size: 0.3733rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
      }
      .list_imgs {
        display: flex;
        justify-content: flex-start;
        margin-top: 0.1rem;
        img {
          width: 3.306rem;
          height: 1.9733rem;
          margin-right: 0.3rem;
        }
      }
      .right_bottom {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 0.266rem;

        img {
          width: 0.4rem;
          height: 0.4rem;

          margin-right: 0.16rem;
        }
        span {
          font-size: 0.32rem;
          color: #999;
        }
        span:nth-of-type(2) {
          position: absolute;
          right: 0;
        }
      }
    }
  }
}
</style>
